var Hash = require('./_Hash'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': Map ? new Map : [],
    'string': new Hash
  };
}

module.exports = mapClear;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_mapClear.js
 ** module id = 70
 ** module chunks = 2 3 4 8 9 10 12 13 14
 **/